export default {
  receptionTitle: "RECEPTION_TITLE",
  receptionDetailTitle: "RECEPTION_DETAIL_TITLE",
  receptionDeclarant: "RECEPTION_DECLARANT",
  receptionCustomer: "RECEPTION_CUSTOMER",
  receptionBlock: "RECEPTION_BLOCK",
  receptionApartment: "RECEPTION_APARTMENT",
  receptionStatus: "RECEPTION_STATUS",
  receptionReference: "RECEPTION_REFERENCE",
  receptionCreatedInfo: "RECEPTION_CREATED_INFO",
  receptionViewPdf: "RECEPTION_VIEW_PDF",
  receptionCharacterProblem: "RECEPTION_CHARACTER_PROBLEM",
  receptionComment: "RECEPTION_COMMENT",
  receptionPhoto: "RECEPTION_PHOTO",
  receptionNumberOfKO: "RECEPTION_NUMBER_OF_KO",
  receptionSeeDetails: "RECEPTION_SEE_DETAILS"
}


// WEBPACK FOOTER //
// ./src/locales/reception/index.ts